import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export function useAccountProfileQuery(params: { impersonationContext?: Api.IImpersonationContext }) {
	const userSession = useUserSession();
	return useQuery<Api.AccountProfile | null>({
		queryFn: async () => {
			try {
				return await userSession.webServiceHelper.callAsync<Api.AccountProfile>(
					Api.ImpersonationBroker.composeApiUrl({
						urlPath: `accountProfile`,
						impersonationContext: params.impersonationContext,
					}),
					'GET'
				);
			} catch (error) {
				if (typeof error === 'object' && error != null && 'systemCode' in error && error.systemCode === 404) {
					return null;
				}
				throw error;
			}
		},
		queryKey: [`accountProfile`, params.impersonationContext],
	});
}

export function invalidateAccountProfileQueries(params: { impersonationContext?: Api.IImpersonationContext }) {
	return reactQueryClient.invalidateQueries({
		queryKey: [`accountProfile`, params.impersonationContext],
	});
}
